import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Set a component's draft context options
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestSetComponentContextOptions = packet => {
  return {
    type: 'REQUEST_SET_COMPONENT_CONTEXT_OPTIONS',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveSetComponentContextOptionsSuccess = data => ({
  type: 'RECEIVE_SET_COMPONENT_CONTEXT_OPTIONS_SUCCESS',
  data
})

export const receiveSetComponentContextOptionsFail = data => ({
  type: 'RECEIVE_SET_COMPONENT_CONTEXT_OPTIONS_FAIL',
  data
})

export const tryToSetComponentContextOptions = packet => (dispatch, getState) => {

  dispatch(requestSetComponentContextOptions(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/components/draft/context-options/' + packet.id, {
      method: 'put',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveSetComponentContextOptionsSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveSetComponentContextOptionsFail({errors:e, lastSubmit: packet}));
    })
}
